export const EXAMPLE_FEES = {
  general_fees: {
    gst_rate: 9.0,
    application_fee_with_gst: 50.0,
    ltv_limit: 80.0,
    current_owner_misc_fee: 5.45,
    proposed_owner_misc_fee: 16.35,
    registration_fee: 38.3,
    registrar_registration_fee: 68.3,
    redemption_of_mortgage: 20,
  },
  specific_fees: [
    {
      flat_type: "01",
      base_valuation_fee_with_gst: 30.0,
      valuation_admin_fee: 20.0,
      tdm: 22.0,
      average_median_price: 330000.0,
    },
    {
      flat_type: "02",
      tdm: 33.0,
      average_median_price: 330000.0,
    },
    {
      flat_type: "03",
      base_valuation_fee_with_gst: 228.9,
      valuation_admin_fee: 20.0,
      tdm: 44.0,
      average_median_price: 400000.0,
    },
    {
      flat_type: "04",
      tdm: 44.0,
      average_median_price: 605000.0,
    },
    {
      flat_type: "05",
      tdm: 55.0,
      average_median_price: 710000.0,
    },
    {
      flat_type: "06",
      tdm: 77.0,
      average_median_price: 847000.0,
    },
  ],
};
